import React, { useState, useEffect, useRef, useCallback } from 'react'
import ReactDOM from 'react-dom'
import cn from 'classnames'
import { useScroll } from 'framer-motion'
import { getImageUrl } from '../utils/assetUtils'
import { useIsMobile, useMediaQuery } from '../hooks/useMediaQuery'

function Feature({ feature, onFocus }) {
  const { title, image } = feature

  const isMobile = useIsMobile()
  const ref = useRef(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  })

  useEffect(() => {
    const unbind = scrollYProgress.onChange((v) => {
      //   console.log(feature.title, v)
      if (v > 0.25 && v < 0.75) onFocus(feature)
    })
    return () => unbind()
  }, [onFocus])

  return (
    <div ref={ref} className={cn('product-feature flex-row:s-up gap-m align-items-center:s-up')}>
      {isMobile && (
        <div className="feature-image">
          <img
            alt={image.title || image.caption || undefined}
            data-object-fit="cover"
            src={getImageUrl(image, { preset: '720w-auto' })}
          />
        </div>
      )}
      <div className="feature-body">
        <h3 className="display-title display-title-m margin-bottom-m">{title}</h3>
        <div className="" dangerouslySetInnerHTML={{ __html: feature.content }} />
      </div>
    </div>
  )
}

function ProductFeatures({ features = [] }) {
  const isMobile = useMediaQuery('(min-width: 320px) and (max-width: 639px)')

  const [focusedFeature, setFocusedFeature] = useState(features[0])
  const handleFocus = useCallback((feature) => {
    setFocusedFeature(feature)
  }, [])

  return (
    <>
      <div className={cn('product-features-container', 'flex-row:s-up gap-xl')}>
        {!isMobile && (
          <div className={cn('focused-feature-image')}>
            {features.map((feature, index) => (
              <img
                key={index}
                alt={feature.image.title || feature.image.caption || undefined}
                data-object-fit="cover"
                src={getImageUrl(feature.image, { preset: '720w-auto' })}
                style={{ opacity: feature === focusedFeature ? 1 : 0 }}
              />
            ))}
          </div>
        )}
        <div className={cn('product-features flex-column:xs gap-xl')}>
          {features.map((feature, index) => (
            <Feature key={index} feature={feature} onFocus={handleFocus} />
          ))}
        </div>
      </div>
    </>
  )
}

window.ProductFeatures = {
  init: (id, props) => {
    ReactDOM.render(<ProductFeatures {...props} />, document.getElementById(id))
  },
}
